import { Controller } from "stimulus"

export default class extends Controller {
  static values = { lots: Array }

  open(event) {
    const btn = event.currentTarget
    const form = document.getElementById("reassign-order-form")
    form.action = btn.dataset.orderUrl

    const salesEventId = btn.dataset.salesEventId
    const salesLotId = btn.dataset.salesLotId

    document.getElementById("reassign-sales-event-select").value = salesEventId || ""
    this._populateLots(salesEventId, salesLotId)

    $("#reassignOrderModal").modal("show")
  }

  filterLots(event) {
    this._populateLots(event.target.value, null)
  }

  _populateLots(salesEventId, preselectedLotId) {
    const lots = this.lotsValue.filter(l => String(l.sales_event_id) === String(salesEventId))
    const select = document.getElementById("reassign-sales-lot-select")

    select.innerHTML = '<option value="">-- Aucun lot --</option>'
    lots.forEach(lot => {
      const option = document.createElement("option")
      option.value = lot.id
      option.text = lot.name
      select.appendChild(option)
    })

    if (preselectedLotId) select.value = String(preselectedLotId)
  }
}
